import { useTheme } from '@emotion/react'
import { Chip, SxProps } from '@mui/material'
import { RosterStatus } from '__generated__/graphql'
import startCase from 'lodash.startcase'
import { FC } from 'react'
import useIsMobile from 'shared/hooks/useIsMobile'
import { getPxAsRem } from 'shared/utils'

interface Props {
    status: RosterStatus | ''
    sx?: SxProps
}

const RosterStatusPill: FC<Props> = ({ status, sx }) => {
    const theme = useTheme()
    const isMobile = useIsMobile()

    const backgroundColor = (() => {
        switch (status) {
            case RosterStatus['Opportunistic']:
                return theme.palette.status.purple
            case RosterStatus['Draft']:
                return theme.palette.status.pink
            case RosterStatus['Active']:
                return theme.palette.primary.main
            case RosterStatus['Closed']:
                return theme.palette.status.green
            case RosterStatus['OnHold']:
                return theme.palette.status.orange
            case RosterStatus['No Status']:
            default:
                return theme.palette.status.grey
        }
    })()

    return (
        <Chip
            title="Search Status"
            size="small"
            label={startCase(status)}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                height: isMobile ? getPxAsRem(18) : undefined,
                ...sx,
            }}
        />
    )
}

export default RosterStatusPill
